import { 
  GetCustomerService,
  GetToken,
  GetUser,
  SaveLoginData, 
  removeLoginData,
} from '@/utils/cookies/index';
import { Message } from "element-ui"
import router from '@/router'
let isOuting = false
let outTimer
export default {
  state: {
    token: GetToken(),
    userInfo: GetUser(),
    customer_service2: GetCustomerService()
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    customer_service2: state => state.customer_service2
  },
  mutations: {
    setLoginData(state, data = {}){
      let { token, userInfo, customer_service2 } = data
      state.token = token
      state.userInfo = userInfo
      state.customer_service2 = customer_service2
      SaveLoginData(data);
    },
    logout(state, isForceOut){
      if(isOuting)
        return
      isOuting = true;
      state.token = ''
      state.userInfo = {}
      state.customer_service2 = ''
      removeLoginData();
      Message({
        type: 'warning',
        message: isForceOut
        ? '登录信息已过期，请重新登录'
        : '您已成功登出'
      })
      router.push({
        name: 'Login',
        query: {
          redirect: router.currentRoute.path
        }
      }).finally(() => {
        if(outTimer)
          clearTimeout(outTimer)
        outTimer = setTimeout(
          () => isOuting = false, 
          1000
        )
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/user.js